// extracted by mini-css-extract-plugin
module.exports = {"paper":"MenuWithAnchor_paper__3FHYx","disabled":"MenuWithAnchor_disabled__3Vw2j"};